"use strict";

import _ from "lodash";
import React from "react";
import { Link } from "react-router";
import moment from "moment";

class Featured_Event extends React.Component {
  constructor(props) {
    super(props);
  }

  renderDate = (city, format, isMultiCity) => {
    let fmt = format ? format : "MMM. D, YYYY";
    if (!city)
      return moment
        .unix(city.date)
        .utcOffset("+0500")
        .format(fmt);

    return !format && city.end && city.start !== city.end
      ? [
          [
            moment
              .unix(city.start)
              .utcOffset("+0500")
              .format("MMM. D"),
            moment
              .unix(city.end)
              .utcOffset("+0500")
              .format("D, YYYY")
          ].join("-"),
          isMultiCity ? "multicity" : city.city
        ].join(" • ")
      : [
          moment
            .unix(city.start)
            .utcOffset("+0500")
            .format(fmt),
          isMultiCity ? "multicity" : city.city
        ].join(" • ");
  };

  render() {
    let eventLink = this.props.event.name
      ? "/conference/" +
        this.props.event.conference_id +
        "/" +
        this.props.event.year
      : this.props.event.link;

    let marketingImg = this.props.event.marketing_img
      ? "/" + this.props.event.marketing_img
      : null;

    let summaryDesc = this.props.event.summary
      ? this.props.event.summary
      : this.props.event.description;

    return (
      <div
        className={
          this.props.inverse
            ? "event clearfix inverse"
            : "feature-wrap clearfix"
        }
      >
        <div className="event-left-wrap">
          {this.props.image && eventLink && marketingImg ? (
            <figure>
              <a href={eventLink}>
                <img className="event-logo" src={marketingImg} />
              </a>
            </figure>
          ) : null}
        </div>

        <div className="event-right-wrap">
          <article itemScope="" itemType="http://schema.org/BusinessEvent">
            
            { _.size(this.props.event.cities) > 1 ?
              <h3 className="date" key={this.props.event.cities[0]._id}>
                {this.props.event.cities[0].tbd ? "TBD": this.renderDate(this.props.event.cities[0], '', true)
                }
              </h3> :
              _.map(this.props.event.cities, (city) => {
                return <h3 className="date" key={city._id}>{city.on_demand ? "On Demand" : city.tbd ? "TBD" : this.renderDate(city)}</h3>
            })}

            {eventLink ? (
              <h1 itemProp="name">
                <a href={eventLink}>
                  {this.props.event.name
                    ? this.props.event.name
                    : this.props.event.title}
                </a>
              </h1>
            ) : null}

            {!summaryDesc ? null : (
              <p
                itemProp="description"
                dangerouslySetInnerHTML={{ __html: summaryDesc }}
              />
            )}

            <ul>
              {_.map(this.props.event.cities, city => {
                return (
                  <li key={city._id}><Link
                    to={eventLink + "/agenda/" + city.city}
                    className="location"
                    key={city._id}
                  >
                    <time itemProp="startDate">{city.on_demand ? "On Demand" : city.tbd ? "TBD" : this.renderDate(city)}</time>
                    <i className="fa fa-angle-right" />
                  </Link></li>
                );
              })}
            </ul>

          </article>
        </div>
      </div>
    );
  }
}

export default Featured_Event;
